import script from "./purchaseDialog.vue?vue&type=script&lang=ts&setup=true"
export * from "./purchaseDialog.vue?vue&type=script&lang=ts&setup=true"

import "./purchaseDialog.vue?vue&type=style&index=0&id=67bfabb7&lang=scss&scoped=true"
import "./purchaseDialog.vue?vue&type=style&index=1&id=67bfabb7&lang=scss"

import exportComponent from "../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+comp_4390a2cfce3e8645dfb3e8bd3a167747/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-67bfabb7"]])

export default __exports__